// extracted by mini-css-extract-plugin
module.exports = {"confirm":"Confirm_confirm__1RWWq","inline-buttons":"Confirm_inline-buttons__cZX6_","message":"Confirm_message__1jYOp"};